export default "__VITE_ASSET__qYlUUFmD__"